import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/LangRout'

export const langRoutService = {
    search,
    getItem,
    saveItem,
    updateItem,
    saveAll,
    updateAll,
};

function search(data) {
    return utilHelper.doRequest(`${relativeUrl}/search`, 'POST', data)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function saveAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/saveAll`, 'POST', data);
}

function updateAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/updateAll`, 'POST', data);
}